import { Collapse } from 'antd';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function R() {
    const { useLang, Link, useRouter } = useGlobal();
    const { t } = useLang('costsaving');
    const { locale } = useRouter();
    let lists: any = [
        {
            title: t('secR_q1'),
            desc: t('secR_a1'),
        },
        {
            title: t('secR_q2'),
            desc: t('secR_a2'),
        },
        {
            title: t('secR_q3'),
            desc: t('secR_a3'),
        },
        {
            title: t('secR_q4'),
            desc: t('secR_a4'),
        },
        {
            title: t('secR_q5'),
            desc: t('secR_a5'),
        },
        {
            title: t('secR_q6'),
            desc: t('secR_a6'),
        },
    ];

    if (locale === 'za') {
        lists = [...lists, { title: t('secR_q7'), desc: t('secR_a7') }, { title: t('secR_q8'), desc: t('secR_a8') }];
    }

    if (locale === 'us') {
        lists.splice(3, 0, { title: t('secR_q9'), desc: t('secR_a9') });
        lists.push({ title: t('secR_q10'), desc: t('secR_a10') });
    }

    return (
        <div id="cost-saving-R" className={`cost-saving-R cost-saving-box ${css['cost-saving-R']}`}>
            <div className="text-info">
                <h2 className="title">{t('secR_title')}</h2>
            </div>
            <Collapse
                ghost={true}
                className="collapse-lists"
                defaultActiveKey={0}
                // onChange={setActive}
                // accordion={true}
                expandIcon={({ isActive }: any) => {
                    return (
                        <svg
                            className={`collapse-icon ${isActive ? 'active' : ''}`}
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 25 24"
                            fill="none"
                        >
                            <path d="M17.5 15L12.5 10L7.5 15" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    );
                }}
                expandIconPosition="right"
            >
                {lists?.map((list: any, k: number) => (
                    <Collapse.Panel className="list-title" key={k} header={list.title}>
                        <p className="list-desc">{list.desc}</p>
                    </Collapse.Panel>
                ))}
            </Collapse>
        </div>
    );
}
